import React from "react";
import ReactDOM from "react-dom/client"; // Updated import for ReactDOM
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Create a root for rendering
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure performance
reportWebVitals(console.log);

/*
reportWebVitals((metric) => {
  // Example: Send metrics to Google Analytics
  window.gtag("event", metric.name, {
    event_category: "Web Vitals",
    value: metric.value,
    label: metric.id,
  });
});
*/ 